<template>
    <v-autocomplete
        v-model="obraSocial"
        variant="solo"
        :items="opcionesOS"
        item-title="nombre"
        return-object
        :rules="obligatorio"
        :loading="cargandoObrasSociales"
        label="Obra social"
        required
        class="asterisco"
        @update:model-value="actualizarOS"
    />
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import FacturadorService from '@/api/FacturadorService';

    const facturadorService = new FacturadorService();

    export default {
        data() {
            return {
                valid: false,
                cargandoObrasSociales: false,
                obraSocial: null,
                opcionesOS: [],
                obligatorio: obligatorio
            }
        },
        async mounted(){
            await this.getObrasSociales();
        },
        methods: {
            async getObrasSociales(){
                this.cargandoObrasSociales = true;
                const facturadorId = this.$store.getters.getFacturador.id;
                const response = await facturadorService.getObrasSociales(facturadorId);
                if(response && response.status === 200){
                    this.opcionesOS = response.data;
                    const ioma = this.opcionesOS.find(os => os.nombre == 'IOMA');
                    if(ioma){
                        this.opcionesOS = this.opcionesOS.filter(os => os.nombre != 'IOMA');
                        this.opcionesOS.unshift(ioma);
                    }
                }
                this.cargandoObrasSociales = false;
            },
            actualizarOS(){
                this.$emit('seleccionar-obraSocial', this.obraSocial);
            }
        }
    }
</script>